import React from 'react';
import './Loader.scss';

export const Loader = () => (
  <div className="spinner">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);
